import { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Import the date picker styles
import './DatePicker.css'; // Import the custom date picker styles

const DatePickerModal = ({ onClose, onDateChange, isDarkMode, completedQuizDates, date, gameMode }) => {
  const [selectedDate, setSelectedDate] = useState(date);
  const [formattedDate, setFormattedDate] = useState(date);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    const formattedDate = DateTime.fromJSDate(date).toFormat('MM/dd/yyyy');
    setFormattedDate(formattedDate);
  };

  const handleSubmit = () => {
    if (formattedDate) {
      onDateChange(formattedDate);  // Pass the formatted date to the parent component
      onClose();  // Close the modal
    }
  };

  const { DateTime } = require("luxon");
  const minDate = gameMode === 'connections' ? new Date(2026, 1, 1) : new Date(2024, 5, 2); // Local Feb 1, 2026 and June 2, 2024

  // Use Date object for maxDate and today boundaries
  const todayUtc = DateTime.utc();
  const maxDate = new Date(todayUtc.year, todayUtc.month - 1, todayUtc.day);

  // Parse YYYY-MM-DD into a local Date object (Midnight Local) for UI consistency
  const formattedSelectedDate = typeof selectedDate === 'string'
    ? new Date(selectedDate.split('-')[0], selectedDate.split('-')[1] - 1, selectedDate.split('-')[2])
    : selectedDate;

  return (
    <div className={isDarkMode ? 'dark-mode' : ''}>
      <div className="date-picker-modal">
        <div className="close-container">
          <button className="modal-close-button" onClick={onClose}>×</button>
        </div>
        <DatePicker
          selected={formattedSelectedDate || maxDate}
          onChange={handleDateChange}
          minDate={minDate}
          maxDate={maxDate}
          dateFormat="MM/dd/yyyy"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          inline
          openToDate={formattedSelectedDate || maxDate}
          // dayClassName={date => {
          //     const formattedDate = date.toLocaleDateString("en-US", {
          //         year: "numeric",
          //         month: "2-digit",
          //         day: "2-digit",
          //     });
          //     return completedQuizDates.includes(formattedDate) ? "completed-quiz-date" : "";
          // }}
          dayClassName={date => {
            const isoDate = DateTime.fromJSDate(date).toISODate();

            // Get today's date in UTC
            const todayUtc = DateTime.utc().startOf('day');
            const currentDayUtc = DateTime.fromJSDate(date).toUTC().startOf('day');

            // Check if the day is 'today' in UTC and if it is in the completed quiz list
            if (currentDayUtc.toISODate() === todayUtc.toISODate()) {
              return "react-datepicker__day--today-utc";
            }

            // Mark completed quizzes
            return completedQuizDates.includes(isoDate) ? "completed-quiz-date" : "";
          }}
        />
        <div className="modal-actions">
          <button className='button-date-picker' onClick={handleSubmit}>Submit</button>
          <button className='button-date-picker secondary' onClick={() => {
            const todayUtc = DateTime.utc();
            const localDateForToday = new Date(todayUtc.year, todayUtc.month - 1, todayUtc.day);
            handleDateChange(localDateForToday);
          }}>Go to Today</button>
        </div>
        <div className="date-legend">
          <h5>🟦 Selected | 🟨 Attempted | 🔲 Today</h5>
        </div>
      </div>
    </div>
  );
};

export default DatePickerModal;
